type SkeletonBoxProps = {
  className?: string;
};

export const SkeletonBox = ({ className }: SkeletonBoxProps) => (
  <div
    className={`
      animate-pulse rounded-md bg-surface-neutral-2
      ${className}
    `}
  />
);
